import Vue from 'vue'
import {Slide} from "vue-carousel";

import Carousel from '../../components/core/Carousel'
import DownloadGuide from '../../views/downloadGuide/DownloadGuide'
import EmailSubscriber from "../../components/EmailSubscriber/EmailSubscriber";

Vue.component('carousel', Carousel)
Vue.component('v-slide', Slide)
Vue.component('download-guide', DownloadGuide)
Vue.component('email-subscriber', EmailSubscriber)

const apps = document.querySelectorAll('.vue-app');

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
